import { Link } from 'react-router-dom'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { BlogPost } from '../types'

interface PostNavigationProps {
  currentPost: BlogPost
  allPosts: BlogPost[]
}

export function PostNavigation({ currentPost, allPosts }: PostNavigationProps) {
  // Get published posts sorted by date
  const publishedPosts = allPosts
    .filter(post => post.published)
    .sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())

  const currentIndex = publishedPosts.findIndex(post => post.id === currentPost.id)
  
  if (currentIndex === -1) {
    return null
  }

  const previousPost = currentIndex > 0 ? publishedPosts[currentIndex - 1] : null
  const nextPost = currentIndex < publishedPosts.length - 1 ? publishedPosts[currentIndex + 1] : null

  if (!previousPost && !nextPost) {
    return null
  }

  return (
    <div className="border-t border-gray-200 py-8">
      <div className="max-w-5xl mx-auto px-6">
        <nav className="flex justify-between items-center">
          {/* Previous Post */}
          <div className="flex-1">
            {previousPost && (
              <Link
                to={`/blog/${previousPost.slug}`}
                className="group flex items-center text-left hover:text-primary-600 transition-colors"
              >
                <div className="flex items-center">
                  <ChevronLeft className="h-5 w-5 text-gray-400 group-hover:text-primary-600 mr-2" />
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Previous</p>
                    <p className="font-medium text-gray-900 group-hover:text-primary-600 line-clamp-2">
                      {previousPost.title}
                    </p>
                  </div>
                </div>
              </Link>
            )}
          </div>

          {/* Back to Blog */}
          <div className="flex-shrink-0 mx-8">
            <Link
              to="/blog"
              className="text-sm text-gray-500 hover:text-primary-600 transition-colors font-medium"
            >
              Back to Blog
            </Link>
          </div>

          {/* Next Post */}
          <div className="flex-1 flex justify-end">
            {nextPost && (
              <Link
                to={`/blog/${nextPost.slug}`}
                className="group flex items-center text-right hover:text-primary-600 transition-colors"
              >
                <div className="flex items-center">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Next</p>
                    <p className="font-medium text-gray-900 group-hover:text-primary-600 line-clamp-2">
                      {nextPost.title}
                    </p>
                  </div>
                  <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-primary-600 ml-2" />
                </div>
              </Link>
            )}
          </div>
        </nav>
      </div>
    </div>
  )
}
